import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { QuoteStatusMessageComponent } from './components/quote-status-message/quote-status-message.component';
import { QuoteResultsComponent } from './components/quote-results/quote-results.component';
import { QuoteReviewActionsComponent } from './components/quote-review-actions/quote-review-actions.component';
import { QuoteSettingsComponent } from './components/quote-settings/quote-settings.component';
import { QuoteComponent } from './components/quote/quote.component';
import { SharedModule } from '@app/shared/shared.module';
import { MaterialModule } from '@app/app.material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OfferComponent } from './components/offer/offer.component';
import { QuoteNoteComponent } from './components/quote-note/quote-note.component';
import { OfferFiltersComponent } from './components/offer-filters/offer-filters.component';
import { CustomOfferComponent } from './components/custom-offer/custom-offer.component';
import { ShareQuoteDialogComponent } from './components/share-quote-dialog/share-quote-dialog.component';
import { ShareQuoteConfigurationComponent } from './components/share-quote-configuration/share-quote-configuration.component';
import {MatTabsModule} from '@angular/material/tabs';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { InlineSVGModule } from 'ng-inline-svg';
import { AddQuoteComponent } from './components/add-quote/add-quote.component';
import { FileManagementModule } from '@app/filemanagement/file-management.module';
import { QuoteNoteDialogComponent } from './components/quote-note-dialog/quote-note-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { GridModule } from '@progress/kendo-angular-grid';
import { QuoteHistoryButtonComponent } from '@app/shared/components/quote-history-button/quote-history-button.component';

@NgModule({
  declarations: [
    QuoteStatusMessageComponent,
    QuoteResultsComponent,
    QuoteReviewActionsComponent,
    QuoteSettingsComponent,
    OfferFiltersComponent,
    QuoteComponent,
    OfferComponent,
    QuoteNoteComponent,
    CustomOfferComponent,
    AddQuoteComponent,
    ShareQuoteDialogComponent,
    ShareQuoteConfigurationComponent,
    QuoteNoteDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatTabsModule,
    ClipboardModule,
    InlineSVGModule,
    FileManagementModule,
    MatButtonModule,
    GridModule,

  ],
  exports: [
    QuoteComponent,
    CustomOfferComponent,
    AddQuoteComponent,
    QuoteNoteComponent,
    QuoteStatusMessageComponent,
    QuoteResultsComponent,
    QuoteReviewActionsComponent,
    OfferFiltersComponent,
    QuoteNoteDialogComponent,
  ],
  providers: [DecimalPipe]
})
export class QuotingModule { }
